module.exports = "/_next/static/images/electrical-f34fbe3d7fa3a2cd3c80f95056243b5f.webp";